import React, { useEffect } from 'react';
import {
  Button,
  FormControl,
  FormLabel,
  OutlinedInput,
  FormHelperText
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { validateNotOnlySpaces } from '@utils/trim-form-values-utils.ts';
import { useErrorMessage } from '@hooks/use-error-message.ts';
import { mediaLibraryErrorMessages } from '@utils/media-library-utils';
import useMediaLibraryStore from '@store/media-library-store/media-library.store.ts';

const RenameMediaContent: React.FC<{
  onSave: (data: { name: string }) => void;
  updateMediaData: any | null;
}> = ({ onSave, updateMediaData }) => {
  const { t } = useTranslation();
  const { isFolderLoading } = useMediaLibraryStore();
  const getErrorMessage = useErrorMessage();

  const {
    register,
    formState: { errors, isValid },
    handleSubmit,
    reset
  } = useForm<any>({ mode: 'onTouched' });

  useEffect(() => {
    if (updateMediaData) {
      reset({ name: updateMediaData?.name });
    }
  }, [updateMediaData, reset]);

  const onSubmit = (data: { name: string }) => onSave(data);

  return (
    <div className="mt-4">
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormControl error={!!errors.name} fullWidth>
          <FormLabel>{t('label_name')}</FormLabel>
          <OutlinedInput
            autoComplete="off"
            {...register('name', {
              required: t('field_required'),
              validate: { notOnlySpaces: validateNotOnlySpaces }
            })}
            placeholder={t('placeholder_name')}
            error={!!errors.name}
          />
          <FormHelperText>
            {errors?.name &&
              getErrorMessage({
                errors,
                fieldName: 'name',
                errorMessages: mediaLibraryErrorMessages
              })}
          </FormHelperText>
        </FormControl>

        <div className="flex justify-end mt-6">
          <Button
            type="submit"
            variant="contained"
            loading={isFolderLoading()}
            disabled={!isValid}
          >
            {t('save')}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default RenameMediaContent;
